import React, { useRef, useState } from 'react';

import { Stack } from '@lyearn/ui';
import { MtfElement } from '@/types/schema';

import LeftElementItem from './components/LeftElementItem';
import RightElementItem from './components/RightElement';
import { ElementsListProps, SelectedElementLayoutType } from './types';

function ElementsList(props: ElementsListProps) {
  const { mtfComponent, questionAttempt, onChange, mtfResponse, correctAnswers } = props;

  const containerRef = useRef<HTMLDivElement | null>(null);
  const isQuestionSubmitted = Boolean(questionAttempt?.isSubmitted);

  const [selectedElementId, setSelectedElementId] = useState('');
  const [selectedElementLayouts, setSelectedElementLayouts] = useState<SelectedElementLayoutType>();

  const onLayout = React.useCallback(
    ({ nativeEvent }: any) =>
      setSelectedElementLayouts((prevValue) => ({
        ...prevValue,
        container: { id: 'container', layout: nativeEvent.layout },
      })),
    [setSelectedElementLayouts],
  );

  return (
    <Stack ref={containerRef} className="relative mt-24 xs:px-20" onLayout={onLayout}>
      <Stack className="w-1/2 me-128 xs:flex-1 xs:me-24" direction="col">
        {mtfComponent.leftElements.map((leftElement, index, array) => {
          const isLast = index === array.length - 1;

          return (
            <LeftElementItem
              key={leftElement.id}
              containerClassName={!isLast ? 'mb-12' : ''}
              containerEl={containerRef.current}
              correctMtfPairings={correctAnswers?.correctMTFPairings}
              element={leftElement as MtfElement}
              index={index}
              isQuestionSubmitted={isQuestionSubmitted}
              mtfResponse={mtfResponse}
              selectedElementId={selectedElementId}
              selectedElementLayouts={selectedElementLayouts}
              setSelectedElementId={setSelectedElementId}
              setSelectedElementLayouts={setSelectedElementLayouts}
              onChange={onChange}
            />
          );
        })}
      </Stack>
      <Stack className="w-1/2 xs:flex-1" direction="col">
        {mtfComponent.distractedRightElements?.map((element, index, array) => {
          const isLast = index === array.length - 1;

          return (
            <RightElementItem
              key={element.id}
              containerClassName={!isLast ? 'mb-12' : ''}
              correctMtfPairings={correctAnswers?.correctMTFPairings}
              element={element as MtfElement}
              index={index}
              isQuestionSubmitted={isQuestionSubmitted}
              mtfResponse={mtfResponse}
              selectedElementId={selectedElementId}
              setSelectedElementId={setSelectedElementId}
              setSelectedElementLayouts={setSelectedElementLayouts}
              onChange={onChange}
            />
          );
        })}
      </Stack>
    </Stack>
  );
}

export default ElementsList;
